<div class="main-container" style="margin-top: 25px;">
    <form [formGroup]="userForm">
        <button type="button" mat-fab color="primary" (click)="openAddUserModal()" matTooltip="add new user" matTooltipPosition="above">
            <mat-icon>add</mat-icon>
        </button>
    </form>
</div>
<ng-template #addUserDialog>
    <form novalidate [formGroup]="userForm" class="users-dialog-form">
    <div class="modal-content" style="min-width: 560px;">
        <h5>Add User</h5>
        <div>
            <div class="input-field col l12 s12 m12" style="margin-top: 20px;">
                <input #userFirstNameInput id="userFirstName" tabindex="1" name="userFirstName" type="text" formControlName="userFirstName" placeholder=" " (blur)="onFieldBlur('userFirstName')">
                <label for="userFirstName">First Name</label>
                <div class="mandatory" [hidden]="!displayMessage.userFirstName">{{displayMessage.userFirstName}}</div>
            </div>
        </div>
        <div>
            <div class="input-field col l12 s12 m12" style="margin-top: 20px;">
                <input id="userLastName" tabindex="1" name="userLastName" type="text" formControlName="userLastName" placeholder=" " (blur)="onFieldBlur('userLastName')">
                <label for="userLastName">Last Name</label>
                <div class="mandatory" [hidden]="!displayMessage.userLastName">{{displayMessage.userLastName}}</div>
            </div>
        </div>
        <div>
            <div class="input-field col l12 s12 m12" style="margin-top: 20px;">
                <input id="userEmail" tabindex="2" name="userEmail" type="text" formControlName="userEmail" placeholder=" " (blur)="onFieldBlur('userEmail')">
                <label for="userEmail">Email</label>
                <div class="mandatory" [hidden]="!displayMessage.userEmail">{{displayMessage.userEmail}}</div>
            </div>
        </div>
        <div>
            <div class="form-group radio-button col l12 s12 m12" style="float: left; margin-top: 20px; margin-left: 8px;">
                <input 
                    class="with-gap" 
                    type="radio" 
                    id="clearance-user"
                    name="userRole"
                    value="clearance-user"
                    formControlName="userRole" 
                    [checked]="userRole=='Clearance'"
                    (change)="optionNewUserRole('Clearance')"/>
                <label style="margin-left: 0px; padding-left: 25px;" for="clearance-user">Clearance User</label>
                <input 
                    class="with-gap" 
                    type="radio" 
                    id="production-user" 
                    name="userRole" 
                    value="production-user"
                    formControlName="userRole" 
                    [checked]="userRole=='Production'"
                    (change)="optionNewUserRole('Production')"/>
                <label style="margin-left: 10px; padding-left: 25px;" for="production-user">Production User</label>
            </div>
        </div>
        <div>
            <div class="switch col l12 s12 m12">
                <span class="switch-title">Readonly user</span>
                <span class="switch-option switch-option-no">No</span>
                <mat-slide-toggle name="readonlyUser" formControlName="readonlyUser"
                  aria-label="Readonly user"></mat-slide-toggle>
                <span class="switch-option switch-option-yes">Yes</span>
            </div>
        </div>
        <div *ngIf="userRole=='Clearance'">
            <div class="switch col l12 s12 m12">
                <span class="switch-title">S&amp;P user</span>
                <span class="switch-option switch-option-no">No</span>
                <mat-slide-toggle name="secondApproval" formControlName="secondApproval"
                  aria-label="S and P user"></mat-slide-toggle>
                <span class="switch-option switch-option-yes">Yes</span>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button (click)="saveUser()" type="submit" mat-button color="primary" [disabled]="!(userForm.valid && userForm.dirty)">Add</button>
        <button type="button" (click)="cancelAddUser()" mat-button>Cancel</button>
    </div>
    </form>
</ng-template>